
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class InvoiceSummary extends Vue {
	@Prop({ type: Array, default: () => [] }) selectedItems!: Array<any>;
	parseTimeToMinutes(timeString: string) {
		let totalMinutes = 0;
		const parts = timeString.match(/(\d+)(h|m)/g);

		if (parts) {
			for (const part of parts) {
				const value = parseInt(part);
				if (part.includes('h')) {
					totalMinutes += value * 60;
				} else if (part.includes('m')) {
					totalMinutes += value;
				}
			}
		}

		return totalMinutes;
	}
	get totalHours() {
		const totalMinutes = this.selectedItems.reduce((total, item) => {
			return total + this.parseTimeToMinutes(item.hours);
		}, 0);

		// If you want to convert minutes back to hours and minutes, you can do so here
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;

		// Format the string to include both hours and minutes
		return `${hours}h ${minutes}m`;
	}

	get totalAmountDue() {
		const totalAmountDue = this.selectedItems.reduce((total, item) => {
			// Remove the currency symbol and convert to a number
			const amount = parseFloat(item.totalAmount.replace('$', ''));
			return total + amount
		}, 0);
		 return parseFloat(totalAmountDue.toFixed(2));
	}
}
